<rav-modal modalTitle="Payment Method" modalId="payment">
  <p>Enter your payment method.</p>

  <ng-form (ngSubmit)="onSubmit()" class="checkout">
    <div class="form-row">
      <label for="card-info">Card Info</label>
      <div id="card-info" class="payment__input" [class.is-invalid-input]="error" #cardInfo></div>

      <div *ngIf="error" role="alert" class="form-error payment__error">{{ error }}</div>
    </div>

    <button type="submit" class="button payment__button" [disabled]="error" [disabled]="isSubmitting">
      <i class="fa fa-lock"></i> Save Card
    </button>
  </ng-form>
</rav-modal>
